module.exports = __webpack_public_path__ + "img/p3-plane.b49e1c77.png";